export enum DYNAMIC_TAG_NAMES {
    occupationRequestedPlayerTag = 'occupationRequestedPlayerTag',
    occupationForcePlayerTag = 'occupationForcePlayerTag',
    defaultHomeVenueCode = 'defaultHomeVenueCode',
    quickDepositPlatform = 'quickDepositPlatform',
    depositPageUrl = 'depositPageUrl',
    atpUrl = 'atpUrl',
    atpVersion = 'atpVersion',
    availableBalances = 'availableBalances',
    singleWalletEnabled = 'singleWalletEnabled',
    depositContactSupportRedirectUrl = 'depositContactSupportRedirectUrl',
    clubsSearchResultUrl = 'clubsSearchResultUrl',
    clubsSearchResultAzUrl = 'clubsSearchResultAzUrl',
    nameOfQueryToTriggerPopup = 'nameOfQueryToTriggerPopup',
    forgottenPasswordUrl = 'forgottenPasswordUrl',
    registrationURL = 'registrationURL',
    showLeftRightMobMenuIcons = 'showLeftRightMobMenuIcons',
    isDownloadAppPrompt = 'isDownloadAppPrompt',
    goTopExcludedPages = 'goTopExcludedPages',
    forgottenMembershipUrl = 'forgottenMembershipUrl',
    forgottenEmailUrl = 'forgottenEmailUrl',
    forgottenDetailsUrl = 'forgottenDetailsUrl',
    uploadDocumentsPageUrl = 'uploadDocumentsPageUrl',
    transferDepositLimitUrl = 'transferDepositLimitUrl',
    fundsTransferPageUrl = 'fundsTransferPageUrl',
    gameSearchTrendingNowFeed = 'gameSearchTrendingNowFeed',
    gameSearchQuickCategoriesFeed = 'gameSearchQuickCategoriesFeed',
    categoryPaths = 'category_paths',
    pggEndpointUrl = 'pggEndpointUrl',
    searchIgnoreFeeds = 'searchIgnoreFeeds',
    searchIgnoreGameTypes = 'searchIgnoreGameTypes',
    lossLimitsPage = 'lossLimitsPage',
    JumioSuccessLibraryPath = 'JumioSuccessLibraryPath',
    JumioErrorLibraryPath = 'JumioErrorLibraryPath',
    tournamentTopCompatitorsCount = 'tournamentTopCompatitorsCount',
    tournamentDefaultImage = 'tournamentDefaultImage',
    diamondLoginRedirectLevel = 'diamondLoginRedirectLevel',
    diamondLoginRedirectFromUrl = 'diamondLoginRedirectFromUrl',
    diamondLoginRedirectUrl = 'diamondLoginRedirectUrl',
    loginAlreadyMemberRedirectUrl = 'loginAlreadyMemberRedirectUrl',
    showContactInfoPopupPlayerTag = 'showContactInfoPopupPlayerTag',
    facebookAppId = 'facebookAppId',
    quickDepositTemplateName = 'quickDepositTemplateName',
    showLoginBtnOnRegistration = 'showLoginBtnOnRegistration',
    occupationsListWebContentId = 'occupationsListWebContentId',
    duplicateAccountPopupButtonUrl = 'duplicateAccountPopupButtonUrl',
    registrationFastTrackUrl = 'registrationFastTrackUrl',
    failedStepForgotPinLink = 'failedStepForgotPinLink',
    forgotAnswerPinStepLink = 'forgotAnswerPinStepLink',
    loginPageUrl = 'loginPageUrl',
    retailUpgradePage = 'retailUpgradePage',
    retailWelcomePage = 'retailWelcomePage',
    slotWelcomePage = 'slotWelcomePage',
    rangesDepositLimit = 'rangesDepositLimit',
    dailyDefaultDepositLimit = 'dailyDefaultDepositLimit',
    weeklyDefaultDepositLimit = 'weeklyDefaultDepositLimit',
    monthlyDefaultDepositLimit = 'monthlyDefaultDepositLimit',
    sourceOfFundsPage = 'sourceOfFundsPage',
    selfExclusionMin = 'selfExclusionMin',
    selfExclusionMax = 'selfExclusionMax',
    selfExclusionSuccessArticleId = 'selfExclusionSuccessArticleId',
    enableSelfExclusionPreferenceChange = 'enableSelfExclusionPreferenceChange',
    myAccountPageUrl = 'myAccountPageUrl',
    stickyFooterHelpPageLink = 'stickyFooterHelpPageLink',
    stickyFooterOver18PageLink = 'stickyFooterOver18PageLink',
    gamesGlobalTotalJackpotUrl = 'gamesGlobalTotalJackpotUrl',
    slotsClubOptedInPlayerTag = 'slotsClubOptedInPlayerTag',
    slotsClubSignupOptedInPlayerTag = 'slotsClubSignupOptedInPlayerTag',
    userDetailsProofIdLink = 'userDetailsProofIdLink',
    userDetailsProofAddressLink = 'userDetailsProofAddressLink',
    atpWidth = 'atpWidth',
    atpHeight = 'atpHeight',
    occupationProvidedPlayerTag = 'occupationProvidedPlayerTag',
    loginSelfExclusionArticleId = 'loginSelfExclusionArticleId',
    loginRetailSelfExclusionArticleId = 'loginRetailSelfExclusionArticleId',
    loginTimeOutArticleId = 'loginTimeOutArticleId',
    loginAccountFrozenArticleId = 'loginAccountFrozenArticleId',
    registrationAccountFrozenArticleId = 'registrationAccountFrozenArticleId',
    allowedNumberOfFailedLoginAttempts = 'allowedNumberOfFailedLoginAttempts',
    childGamesCategories = 'childGamesCategories',
    postcodeFindConfigurationUrl = 'postcodeFindConfigurationUrl',
    postcodeConfigurationKey = 'postcodeConfigurationKey',
    postcodeInternationalGeocodingKey = 'postcodeInternationalGeocodingKey',
    postcodeInternationalGeocodingUrl = 'postcodeInternationalGeocodingUrl',
    postcodeConfigurationUrl = 'postcodeConfigurationUrl',
    clubsListUrl = 'clubsListUrl',
    locationListId = 'locationListId',
    clubsListAPIKey = 'clubsListAPIKey',
    timezoneOffsetParameter = 'timezoneOffsetParameter',
    paymentStatisticUpdateDelay = 'paymentStatisticUpdateDelay',
    disablePinValidation = 'disablePinValidation',
    clubAPIUrl = 'clubAPIUrl',
    useServicesEyeconJackpots = 'useServicesEyeconJackpots',
    eyeconJackpotUrl = 'eyeconJackpotUrl',
    gamesGlobalJackpotUrl = 'gamesGlobalJackpotUrl',
    gamesGlobalJackpotPrefix = 'gamesGlobalJackpotPrefix',
    transactionHistoryAmountClientPlatform = 'transactionHistoryAmountClientPlatform',
    twoFactorAuthenticationOptions = 'twoFactorAuthenticationOptions',
    inboxShowMessageButton = 'inboxShowMessageButton',
    idvConfirmTag = 'idvConfirmTag',
    beforeIdvChangeDetailsDelay = 'beforeIdvChangeDetailsDelay',
    afterIdvChangeDetailsDelay = 'afterIdvChangeDetailsDelay',
    jumioVerificationTimeout = 'jumioVerificationTimeout',
    jumioAfterPassedPageUrl = 'jumioAfterPassedPageUrl',
    jumioUploadPageUrl = 'jumioUploadPageUrl',
    jumioUpdateInformationPopupHide = 'jumioUpdateInformationPopupHide',
    wifiPageUrl = 'wifiPageUrl',
    LegacyCardStartingNumber = 'LegacyCardStartingNumber',
    logoutParamAllSessions = 'logoutParamAllSessions',
    logoutParamRealMode = 'logoutParamRealMode',
    logoutParamBehaviour = 'logoutParamBehaviour',
    logoutParamInvalidateRememberMe = 'logoutParamInvalidateRememberMe',
    playerTagsForHidden = 'playerTagsForHidden',
    quickDepositBlockTags = 'quickDepositBlockTags',
    clubsShowMoreCount = 'clubsShowMoreCount',
    genderList = 'genderList',
    orderSecurityQuestionOptions = 'orderSecurityQuestionOptions',
    blockedCities = 'blockedCities',
    blockedZips = 'blockedZips',
    passwordBlockedWords = 'passwordBlockedWords',
    invalidRegPins = 'invalidRegPins',
    upgradePortalPageUrl = 'upgradePortalPageUrl',
    occupationMandatoryPlayerTag = 'occupationMandatoryPlayerTag',
    retailSuspensionTagName = 'retailSuspensionTagName',
    loginRetailSuspensionArticleId = 'loginRetailSuspensionArticleId',
    occupationOptionalProvidedPlayerTag = 'occupationOptionalProvidedPlayerTag',
    occupationOptionalNonePlayerTag = 'occupationOptionalNonePlayerTag',
    detailsRecovery = 'detailsRecovery',
    // use in useRegNavigationAfterLogin
    desktopAfterRegisterUrl = 'desktopAfterRegisterUrl',
    tabletAfterRegisterUrl = 'tabletAfterRegisterUrl',
    mobileAfterRegisterUrl = 'mobileAfterRegisterUrl',
    lowBalancePlayerTag = 'lowBalancePlayerTag',
    lowBalanceExcludePlayerTag = 'lowBalanceExcludePlayerTag',
    retailWrapperRegisterPlayerTags = 'retailWrapperRegisterPlayerTags',
    retailWrapperUpgradePlayerTags = 'retailWrapperUpgradePlayerTags',
    verifyMarketingPreferencesPlayerTag = 'verifyMarketingPreferencesPlayerTag',
    headerBalanceType = 'headerBalanceType',
    voiceGameSearch = 'voiceGameSearch'
}
